

// @mui material components
import Card from "@mui/material/Card";

// Dashboard React components
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";

// Billing page components
import Bill from "layouts/billing/components/Bill";

function BillingInformation() {
  return (
    <Card id="delete-account">
      <DSBox pt={3} px={2}>
        <DSTypography variant="h6" fontWeight="medium">
          Billing Information
        </DSTypography>
      </DSBox>
      <DSBox pt={1} pb={2} px={2}>
        <DSBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
          
          <Bill
            name="Jason Lee"
            company="Felix Tech"
            email="jason.lee@felix-tech.com"
            vat="ABR233476"
          />
          <Bill
            name="ethan hunt"
            company="Laiz Industries"
            email="ehunt@laizin.com"
            vat="QRD4435476"
            noGutter
          />
        </DSBox>
      </DSBox>
    </Card>
  );
}

export default BillingInformation;
